import { render, staticRenderFns } from "./video_list.vue?vue&type=template&id=9f7265d8&scoped=true"
import script from "./video_list.vue?vue&type=script&lang=js"
export * from "./video_list.vue?vue&type=script&lang=js"
import style0 from "./video_list.vue?vue&type=style&index=0&id=9f7265d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7265d8",
  null
  
)

export default component.exports